import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=22d52e9e&lang=pug&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d52e9e')) {
      api.createRecord('22d52e9e', component.options)
    } else {
      api.reload('22d52e9e', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=22d52e9e&lang=pug&", function () {
      api.rerender('22d52e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/summary/summary.vue"
export default component.exports